var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tips"},[_c('i',{staticClass:"icon_tips",class:_vm.tipsIcon}),_c('span',{staticClass:"tipsContent"},[_vm._v(_vm._s(_vm.tipsContent))])])
}
var staticRenderFns = []

export { render, staticRenderFns }